// Module
var code = "<svg fill=\"none\" stroke=\"currentColor\" width=\"100%\" height=\"100%\" viewBox=\"5 5 14 14\" xmlns=\"http://www.w3.org/2000/svg\"> <path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" d=\"M12 6v6m0 0v6m0-6h6m-6 0H6\"></path> </svg>";
// Exports
module.exports = code;